<template>
  <div class="mapped-data" style="height: 370px;">
     <l-map
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      class="h-100"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      />
      <l-marker  v-for="(popupItem, l) in mapData" :key="'popupItem' + l" 
        :lat-lng="getLatLng(popupItem.Lat_Long)">
        <l-popup>
          <div @click="innerClick">
            {{popupItem.title}}
            {{popupItem.city}}
            {{popupItem.country}}
            {{popupItem.year}}

          </div>
        </l-popup>
      </l-marker>
     <!-- <l-marker :lat-lng="withTooltip">
        <l-tooltip :options="{ permanent: true, interactive: true }">
          <div @click="innerClick">
            I am a tooltip
            <p v-show="showParagraph">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.
              Donec finibus semper metus id malesuada.
            </p>
          </div>
        </l-tooltip>
      </l-marker>-->
    </l-map>
  </div>
</template>

<script>
import { Icon, latLng } from "leaflet";
import 'leaflet/dist/leaflet.css'
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
import {  LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet' //LTooltip
export default {
  name: 'MappedData',
  components: { 
   LMap,
    LTileLayer,
    LMarker,
    LPopup,
    //LTooltip
  },
  props: ["metaData"],
  data() {
    return {
      mapData: [],
      zoom: 3,
      center: latLng(39.639538, 20.039063),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 3,
      currentCenter: latLng(39.639538, 20.039063),
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true
    }
  },  
  mounted() {
    setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 1250);
    this.filterData() 
  },
  methods: {
    filterData () {
      this.mapData = this.metaData.filter (  item => item.Lat_Long  )  
    },
/*     filterData () {
      setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 2500);
      this.mapData = []
      this.flatData()     
      this.mapData = this.mapData.filter (
        item => (parseInt(item.Year) >= this.yearRange[0] &&  parseInt(item.Year) <= this.yearRange[1]))       
    }, */
    getLatLng (LatLngString) {
      if (LatLngString && LatLngString.length> 3) {  
        let spl = LatLngString.split(',') 
        return latLng(parseFloat(spl[0]), parseFloat(spl[1]))  
      } else {
          return this.center
      }
    },   
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    innerClick() {
      
    }
  },
  watch: {
   /*  yearRange () {     
      this.filterData()
    } */
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    }   
  }
}
</script>  
<style scoped lang="scss">

</style>